import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@chatterbug/aaron'

// The idea behind this component is to provide a basic anchor tag that can
// be used to wrap anything, to leverage the accessibility features of an
// link (such as focus, being able to open the element in a new tab)

// Focus and the ability to open the link in a new tab  will only happen if
// the link is provided an href attribute (via the linkUrl prop)
// If you need something different to happen onClick, you can pass in an onClick
// function

const Pressable = ({
  disabled,
  onClick,
  linkUrl,
  altText,
  children,
  ...rest
}) => {
  let props = {}

  if (!disabled && linkUrl) {
    props = {
      as: 'a',
      href: linkUrl,
      onClick,
    }
  } else if (!disabled && onClick) {
    props = {
      as: 'button',
      type: 'button',
      onClick,
    }
  }

  return (
    <Box
      aria-label={altText}
      css={`
        color: black;
        background: transparent;
        border: none;
        border-radius: 0;
        padding: 0;
        margin: 0;
        :hover,
        :focus {
          color: black;
          text-decoration: none;
        }
      `}
      {...props}
      {...rest}
    >
      {children}
    </Box>
  )
}

Pressable.propTypes = {
  altText: PropTypes.string,
  disabled: PropTypes.bool,
  linkUrl: PropTypes.string,
  onClick: PropTypes.func,
}

export default Pressable
